<template>
  <div>
    <!-- search -->
    <search @getLogAnalysis="getLogAnalysis"></search>
    <div class="analysis_button">
      <a :class="logType === 1 ? 'color':''" @click="selectLogType(1)">环节分析</a>
      <a :class="logType === 2 ? 'color':''" @click="selectLogType(2)">民警数分析</a>
      <a :class="logType === 3 ? 'color':''" @click="selectLogType(3)">耗时分析</a>
      <a :class="logType === 4 ? 'color':''" @click="selectLogType(4)">操作终数分析</a>
      <a :class="logType === 5 ? 'color':''" @click="selectLogType(5)">操作时段分析</a>
    </div>
    <div class="chart-content">
      <div class="chart-box">
        <div class="ui-fullBox">
          <smart-chart id="chart2" :echart-option="chartData.bar" :resizeable="true" />
        </div>
      </div>

    </div>
  </div>
</template>
<script>
import Search from './search';
// import pieChart from '../comm/charts/pieChart';
// import barChart from '../comm/charts/barChart';
import SmartChart from '@/components/smartChart';
import BarOption from '@/components/smartChart/options/bar';
import PieOption from '@/components/smartChart/options/singelPie';

export default {
  name: 'logAnalysis',
  components: {
    Search,
    // pieChart,
    // barChart，
    SmartChart
  },
  data() {
    return {
      chartData: {
        bar: {
          loading: false,
          ...BarOption
        },
        pie: {
          loading: false,
          ...PieOption
        }
      },
      queryParams: {},
      logType: 1 // 日志分析的类型
    };
  },
  methods: {
    getLogAnalysis(params) {
      if (params) {
        Object.assign(this.queryParams, this.queryParams, params);
      }
      this.selectLogType(this.logType);
    },
    selectLogType(logType) {
      this.logType = logType;
      switch (logType) {
        case 1:
          this.getHierarchyNumProportion();
          break;
        case 2:
          this.getPoliceNumProportion();
          break;
        case 3:
          this.getAnalyseConsumeTime();
          break;
        case 4:
          this.getAnalyseTerminal();
          break;
        case 5:
          this.getAnalyseTimeSegment();
          break;
        default:
      }
    },
    /**
     * parse bean to option data
     */
    parseOption(bean, _name, _keyNum, _keyType) {
      let maxLength = 0;
      let op = {
        x: [],
        series: null,
        legend: []
      };

      // 判断serises个数
      // eslint-disable-next-line guard-for-in
      for (let key in bean) {
        op.x.push(key);
        if (bean[key].length > maxLength) {
          maxLength = bean[key].length;
        }
      }
      op.series = new Array(maxLength);
      if (typeof bean === 'object') {
        for (let i = 0; i < op.series.length; i++) {
          let s_item = {
            name: null,
            type: 'bar',
            data: []
          };
          // eslint-disable-next-line guard-for-in
          for (let key in bean) {
            let value = 0;
            if (bean[key][i]) {
              if (!s_item.name) {
                s_item.name = _name + bean[key][i][_keyType];
                op.legend.push(s_item.name);
              }

              value = bean[key][i][_keyNum];
            }
            s_item.data.push(value);
          }

          op.series[i] = s_item;
        }
      }

      return op;
    },
    /**
     * 由3层对象转echarts 数组
     */
    parseArra(data) {
      let result = {
        map: {},
        x: [],
        len: [],
        series: []
      };

      let isOtherExtra = false;
      /**
       * 遍历出x轴 array 和legend array
       */
      // eslint-disable-next-line guard-for-in
      for (let xVal in data) {
        result.x.push(xVal);
        let lenObj = data[xVal];
        for (let lenVal in lenObj) {
          if (!result.len.includes(lenVal)) {
            if (lenVal === '其他') {
              isOtherExtra = true;
            }
            else {
              result.len.push(lenVal);
            }
          }
        }
      }
      // 额外处理其他
      if (isOtherExtra) {
        result.len.push('其他');
      }
      /**
       * 根据legend 遍历出series item
       */
      for (let lenIndex = 0; lenIndex < result.len.length; lenIndex++) {
        let legend = result.len[lenIndex];
        let itemSeries = {
          name: legend,
          type: 'bar',
          label: {
            show: result.len.length <= 3,
            formatter(param) {
              return param.value === 0 ? '' : param.value;
            }
          },
          data: []
        };
        // 根据x轴 遍历每个 data 值
        for (let xIndex = 0; xIndex < result.x.length; xIndex++) {
          let xValue = result.x[xIndex];
          itemSeries.data.push(data[xValue][legend]);
        }

        result.series.push(itemSeries);
      }

      return result;
    },
    setOption(option, data) {
      option.legend.data = data.len;
      option.xAxis[0].data = data.x;
      option.series = data.series;
      option.loading = true;
    },
    /**
     * 环节分析
     */
    async getHierarchyNumProportion() {
      let option = this.chartData.bar;
      option.loading = false;
      const { bean } = await this.$services.post({
        type: 'LOGANALYSIS',
        url: 'getHierarchyNumProportion',
        params: this.queryParams
      });
      let oData = {};
      // eslint-disable-next-line guard-for-in
      for (let key in bean) {
        let itemArry = bean[key];
        if (!oData[key]) {
          oData[key] = {};
          for (let j = 0; j < itemArry.length; j++) {
            let item = itemArry[j];
            oData[key]['层级' + item.departNumType] = item.departNum;
          }
        }
      }

      let op = this.parseArra(oData);

      this.setOption(option, op);
      // option.legend.data = op.len;
      // option.xAxis[0].data = op.x;
      // option.series = op.series;
      // option.loading = true;
    },
    /**
     * 民警数
     */
    async getPoliceNumProportion() {
      let option = this.chartData.bar;
      option.loading = false;
      const { bean } = await this.$services.post({
        type: 'LOGANALYSIS',
        url: 'getPoliceNumProportion',
        params: this.queryParams
      });

      let oData = {};
      // eslint-disable-next-line guard-for-in
      for (let key in bean) {
        let itemArry = bean[key];
        if (!oData[key]) {
          oData[key] = {};
          for (let j = 0; j < itemArry.length; j++) {
            let item = itemArry[j];
            oData[key]['民警' + item.policeNumType] = item.policeNum;
          }
        }
      }
      let op = this.parseArra(oData);

      this.setOption(option, op);
    },
    /**
     * 操作终端
     */
    async getAnalyseTerminal() {
      let option = this.chartData.bar;
      option.loading = false;
      const { bean } = await this.$services.post({
        type: 'LOGANALYSIS',
        url: 'getAnalyseTerminal',
        params: this.queryParams
      });
      let oData = {};
      // eslint-disable-next-line guard-for-in
      for (let key in bean) {
        let itemArry = bean[key];
        if (!oData[key]) {
          oData[key] = {};
          for (let j = 0; j < itemArry.length; j++) {
            let item = itemArry[j];
            oData[key]['终端' + item.terminalNumType] = item.terminalNum;
          }
        }
      }
      let op = this.parseArra(oData);

      this.setOption(option, op);
    },
    /**
     * 单据耗时
     */
    async getAnalyseConsumeTime() {
      let option = this.chartData.bar;
      option.loading = false;
      const { bean } = await this.$services.post({
        type: 'LOGANALYSIS',
        url: 'getAnalyseConsumeTime',
        params: this.queryParams
      });
      let oData = {};
      // eslint-disable-next-line guard-for-in
      for (let key in bean) {
        let itemArry = bean[key];
        if (!oData[key]) {
          oData[key] = {};
          for (let j = 0; j < itemArry.length; j++) {
            let item = itemArry[j];
            oData[key]['民警' + item.operateType] = item.consumeSeconds;
          }
        }
      }
      let op = this.parseArra(oData);

      this.setOption(option, op);
    },
    /**
     * 操作时段耗时
     */
    async getAnalyseTimeSegment() {
      let option = this.chartData.bar;
      option.loading = false;
      const { bean } = await this.$services.post({
        type: 'LOGANALYSIS',
        url: 'getAnalyseTimeSegment',
        params: this.queryParams
      });

      let oData = {};
      // eslint-disable-next-line guard-for-in
      for (let key in bean) {
        let itemArry = bean[key];

        for (let j = 0; j < itemArry.length; j++) {
          let item = itemArry[j];
          if (!oData[item.operateHour]) {
            oData[item.operateHour] = {};
          }
          oData[item.operateHour][key] = item.operateNumber;
        }
      }
      let op = this.parseArra(oData);

      this.setOption(option, op);
    }
  },
  created() {
    this.getLogAnalysis();
  }
};
</script>
<style lang="scss" scoped>
.analysis_button {
  margin-top: 20px;
  a {
    width: 15%;
    height: 40px;
    line-height: 40px;
    text-align: center;
    display: inline-block;
    margin-right: 10px;
    box-shadow: 0px 0px 5px #999;
    cursor: pointer;
  }

  a.color {
    background: #66b1ff;
    color: #fff;
    box-shadow: 0px 0px 5px #66b1ff;
  }

  a:first-child {
    margin-left: 30px;
  }
}

.chart-content {
  padding-top: 20px;
  .chart-box {
    height: 30vw;
    #chart1,
    #chart2 {
      height: 100%;
      width: 99.8%;
    }
  }
}
</style>
